import React from 'react';
import { PhoneSignal } from '@saleshandy/icons';

const CallOutcomeSignal = () => (
  <PhoneSignal width={16} height={16} className="purple-txt-16" />
);

export default CallOutcomeSignal;
